export default window.config.frontend
